export enum WorkspaceMeetingModeState {
  WORKSPACE_ITEM_TRAVERSAL = 'workspace_item_traversal',
  NEXT_STEPS = 'next_steps',
  END = 'end',
  END_MEETING_MODE_SESSION = 'end_meeting_mode_session',
}

export type WorkspaceMeetingMode = {
  numSteps: number;
  stepIndex: number;
  participantIds: Array<number>;
  state: WorkspaceMeetingModeState;
  workspaceItemId: number;
  workspaceItemUuid: string;
  workspaceSlug: string;
  createdAt: Date;
};

export type BotAttributes = {
  organizationSlug: string;
  workspaceSlug: string;
  recallBotId: string;
  isComplete: boolean;
  startedAt: string | null;
  endedAt: string | null;
  createdAt: string;
  updatedAt: string;
};
